var _g, _g2, _g3, _g4, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 144,
    viewBox: "0 0 145 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#area_svg__filter0_d_3871_29540)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.211,
    y: 10,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#F6F8FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#area_svg__filter1_d_3871_29540)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.211,
    y: 25,
    width: 90,
    height: 90,
    rx: 45,
    fill: "#F6F8FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#area_svg__filter2_d_3871_29540)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.211,
    y: 40,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F6F8FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#area_svg__filter3_d_3871_29540)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.711,
    y: 54.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#F6F8FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.853 22.76c8.97 8.97 9.217 23.435.559 32.706l-17.2 18.416-17.2-18.416c-8.66-9.271-8.413-23.736.557-32.706 9.191-9.192 24.093-9.192 33.284 0z",
    fill: "#1B264F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.614 47.023a7.868 7.868 0 01-1.585-1.105l-.435-.426-.034-.036-2.867-2.812-.002.006-5.676-5.555c-.163-.17-.1-.105-.205-.198-.625-.555-1.585-.936-2.338-.922a3.275 3.275 0 00-2.196.87l-3.395-3.26c.351-.278.73-.528 1.135-.752 1.293-.702 2.755-1.068 4.385-1.098 1.653-.03 3.126.282 4.42.937.572.29 1.092.634 1.56 1.032l8.943 8.743.015.018.693.68c.57.436 1.223.654 1.962.654.951 0 1.773-.362 2.466-1.086.67-.702 1.005-1.652 1.005-2.85 0-1.2-.335-2.15-1.005-2.851-.693-.702-1.514-1.052-2.466-1.052-.952 0-1.763.35-2.433 1.052a3.354 3.354 0 00-.606.838l-3.523-3.406a7.713 7.713 0 012.182-1.708c1.276-.679 2.736-1.018 4.38-1.018 1.622 0 3.082.34 4.38 1.018a7.874 7.874 0 013.05 2.85c.735 1.222 1.103 2.647 1.103 4.276 0 1.652-.368 3.088-1.103 4.31a7.875 7.875 0 01-3.05 2.85c-1.298.68-2.758 1.019-4.38 1.019-1.644 0-3.104-.34-4.38-1.018zM52.965 39.45l5.117-.215c.038-.329.107-.636.206-.92l-3.646-3.497c-.233.289-.448.596-.644.923-.63 1.078-.974 2.315-1.033 3.71zM64.532 42.05a3.374 3.374 0 01-.498.667c-.497.535-1.076.874-1.737 1.018l.16 4.274c1.334-.117 2.534-.47 3.6-1.06a7.81 7.81 0 002.026-1.59l-3.551-3.309zM58.459 41.88l-3.301 3.712a7.992 7.992 0 01-1.02-1.272c-.572-.91-.936-1.94-1.091-3.088l5.119-.216c.068.311.165.6.293.865zM60.746 48.025l-.163-4.344a3.295 3.295 0 01-.979-.466l-3.092 3.476c.236.152.483.292.74.422 1.062.526 2.226.83 3.494.912z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.614 47.023a7.868 7.868 0 01-1.585-1.105l-.435-.426-.034-.036-2.867-2.812-.002.006-5.676-5.555c-.163-.17-.1-.105-.205-.198-.625-.555-1.585-.936-2.338-.922a3.275 3.275 0 00-2.196.87l-3.395-3.26c.351-.278.73-.528 1.135-.752 1.293-.702 2.755-1.068 4.385-1.098 1.653-.03 3.126.282 4.42.937.572.29 1.092.634 1.56 1.032l8.943 8.743.015.018.693.68c.57.436 1.223.654 1.962.654.951 0 1.773-.362 2.466-1.086.67-.702 1.005-1.652 1.005-2.85 0-1.2-.335-2.15-1.005-2.851-.693-.702-1.514-1.052-2.466-1.052-.952 0-1.763.35-2.433 1.052a3.354 3.354 0 00-.606.838l-3.523-3.406a7.713 7.713 0 012.182-1.708c1.276-.679 2.736-1.018 4.38-1.018 1.622 0 3.082.34 4.38 1.018a7.874 7.874 0 013.05 2.85c.735 1.222 1.103 2.647 1.103 4.276 0 1.652-.368 3.088-1.103 4.31a7.875 7.875 0 01-3.05 2.85c-1.298.68-2.758 1.019-4.38 1.019-1.644 0-3.104-.34-4.38-1.018zM52.965 39.45l5.117-.215c.038-.329.107-.636.206-.92l-3.646-3.497c-.233.289-.448.596-.644.923-.63 1.078-.974 2.315-1.033 3.71zM64.532 42.05a3.374 3.374 0 01-.498.667c-.497.535-1.076.874-1.737 1.018l.16 4.274c1.334-.117 2.534-.47 3.6-1.06a7.81 7.81 0 002.026-1.59l-3.551-3.309zM58.459 41.88l-3.301 3.712a7.992 7.992 0 01-1.02-1.272c-.572-.91-.936-1.94-1.091-3.088l5.119-.216c.068.311.165.6.293.865zM60.746 48.025l-.163-4.344a3.295 3.295 0 01-.979-.466l-3.092 3.476c.236.152.483.292.74.422 1.062.526 2.226.83 3.494.912z",
    stroke: "#1B264F",
    strokeWidth: 0.527
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "area_svg__filter0_d_3871_29540",
    x: 0.211,
    y: 0,
    width: 144,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.155 0 0 0 0 0.231506 0 0 0 0 0.516667 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3871_29540"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3871_29540",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "area_svg__filter1_d_3871_29540",
    x: 15.211,
    y: 15,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.155 0 0 0 0 0.231506 0 0 0 0 0.516667 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3871_29540"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3871_29540",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "area_svg__filter2_d_3871_29540",
    x: 30.211,
    y: 30,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.155 0 0 0 0 0.231506 0 0 0 0 0.516667 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3871_29540"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3871_29540",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "area_svg__filter3_d_3871_29540",
    x: 44.711,
    y: 44.5,
    width: 55,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.155 0 0 0 0 0.231506 0 0 0 0 0.516667 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3871_29540"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3871_29540",
    result: "shape"
  })))));
}
export default __webpack_public_path__ + "media/photographerOnboarding/area-fa603611.svg";
export { SvgArea as ReactComponent };